import React, { Component } from 'react';
import { connect } from 'react-redux';
//import ReactEcharts from 'echarts-for-react';
import 'react-step-progress-bar/styles.css';
import {
  ProgressBar,
  Step
} from 'react-step-progress-bar';
import {
  saveScore
} from '../../actions/client';
import {
  LF_TEST,
} from '../../constants.js';
import {
  getScrollBase,
} from './functions.js';
import TestResult from './TestResult';
import s from './LossFrequency.css';
import cs from './common.css';


class LossFrequency extends Component {

  constructor() {
    super();
    this.state = {
      qNum: 0,
      questions: [1, 2, 3, 4, 5, 6],
      answers: ['', '', '', '','', ''],
    };
  }

  componentDidMount() {
    const panes = this.generateQuestions();
    this.setState(Object.assign({}, this.state, {
      panes: panes,
    }));
    this.getNextQuestion();
  }

  getNextQuestion(e) {
    let qNum = 7;
    // copy questions
    const questions = [].concat(this.state.questions);
    // if more questions get and remove one randomly
    if (questions.length > 0) {
      qNum = questions.shift();
    }
    // update the state with current num and remaining questions
    if (qNum === 7) {
      this.props.saveScore(LF_TEST, this.state.answers);
    }
    this.setState(Object.assign({}, this.state, {
      qNum: qNum,
      questions: questions,
    }));
  }

  answerQuestion(value) {
    const {
      qNum,
    } = this.state;
    const answers = [].concat(this.state.answers);
    // set answer, get next question
    answers[qNum - 1] = value;
    this.setState(Object.assign({}, this.state, {
      answers: answers,
    }), () => {
      this.getNextQuestion();
    });
  }

  render() {
    const {
      qNum,
      questions,
      panes,
    } = this.state;
  
    if (qNum === 7) {
      return (
        <TestResult />
      );
    } else {
      const scrollBase = getScrollBase();
      const ctrans = `translate(${-(((qNum - 1) * 30) + ((qNum - 1) * scrollBase))}px)`;
      return (
        <div>
          <div className="row">
            <div className="col-md-12">
              <div className={cs.headerRow}>
                <ProgressBar
                  unfilledBackground="#BDC2C6"
                  filledBackground="#35ccd2"
                  height='1px'
                  percent={100 / 5 * Math.abs(5 - questions.length)}
                >
                  <Step transition="scale">
                    {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                  </Step>
                </ProgressBar>
              </div>
              <div className={cs.headerTitle}>Mental Accounting of Losses Assessment: How often do you feel the pain of investment losses?</div>
            </div>
          </div>
          <div className="row">
            <div className={'col-md-12'} style={{ overflow:'hidden',paddingTop:'30px',paddingBottom:'30px'}}>
              <div className={cs.insidepane} style={{ transform: ctrans }}>
                {panes}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  generateQuestions() {
    return (
      <div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
          How often do you generally evaluate the
          performance of your investment portfolio?
          </div>
          <div className="row">
            <div className="col-md-12" style={{textAlign:'center'}}>
              <div><button onClick={() => this.answerQuestion(5)} className={s.oneButton}>Daily or weekly</button></div>
              <div><button onClick={() => this.answerQuestion(4)} className={s.oneButton}>Monthly or quarterly</button></div>
              <div><button onClick={() => this.answerQuestion(3)} className={s.oneButton}>Annually</button></div>
              <div><button onClick={() => this.answerQuestion(2)} className={s.oneButton}>Every few years</button></div>
              <div><button onClick={() => this.answerQuestion(1)} className={s.oneButton}>Never</button></div>
            </div>
          </div>
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
          During periods of market volatility or market
          downturns, how anxious do you feel about your investments on a
          5-point scale, with 1 being “not anxious at all” and 5 being
          "extremely anxious"?      
          </div>
          <div className="row">
            <div className="col-md-12" style={{ textAlign: 'center'}}>
              <button onClick={() => this.answerQuestion(1)} className={s.twoButton}>1</button>
              <button onClick={() => this.answerQuestion(2)} className={s.twoButton}>2</button>
              <button onClick={() => this.answerQuestion(3)} className={s.twoButton}>3</button>
              <button onClick={() => this.answerQuestion(4)} className={s.twoButton}>4</button>
              <button onClick={() => this.answerQuestion(5)} className={s.twoButton}>5</button>
            </div>
          </div>
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
          Do you use any apps to regularly check on the
          performance of your investments?
          </div>
          <div className="row">
            <div className="col-md-12" style={{textAlign:'center'}}>
              <button onClick={() => this.answerQuestion(1)} className={s.threeButton}>NO</button>
              <button onClick={() => this.answerQuestion(5)} className={s.threeButton}>YES</button>
            </div>
          </div>
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
          Suppose that you have an opportunity to bet on coin flips in which
          you win $250 if the coin lands on heads and lose $100 if the coin
          lands on tails. Would you play this bet <strong>two</strong> times?
          </div>
          <div className="row">
            <div className="col-md-12" style={{textAlign:'center'}}>
              <button onClick={() => this.answerQuestion('n')} className={s.fourButton}>NO</button>
              <button onClick={() => this.answerQuestion('y')} className={s.fourButton}>YES</button>
            </div>
          </div>
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
          Would you accept a bet in which you have the
          following chances of winning or losing?
          </div>
          <div className="row">
            <div className="col-md-12" style={{textAlign:'center'}}>
              <div style={{fontSize:'20px', textAlign:'left', display:'inline-block'}}>
                25% chance of winning $500<br />
                50% chance of winning $150<br />
                25% chance of losing  $200<br /><br />
              </div>
              <div style={{display:'block'}}>
                <button onClick={() => this.answerQuestion('n')} className={s.fiveButton}>NO</button>
                <button onClick={() => this.answerQuestion('y')} className={s.fiveButton}>YES</button>
              </div>
            </div>
          </div>
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
          I often set a goal but later choose to pursue a different one.
          </div>
          <div className="row">
            <div className="col-md-12" style={{textAlign:'center'}}>
              <div><button onClick={() => this.answerQuestion(5)} className={s.sixButton}>Very much like me</button></div>
              <div><button onClick={() => this.answerQuestion(4)} className={s.sixButton}>Mostly like me</button></div>
              <div><button onClick={() => this.answerQuestion(3)} className={s.sixButton}>Somewhat like me</button></div>
              <div><button onClick={() => this.answerQuestion(2)} className={s.sixButton}>Not much like me</button></div>
              <div><button onClick={() => this.answerQuestion(1)} className={s.sixButton}>Not like me at all</button></div>
            </div>
          </div>
        </div>
      </div>
    );

  
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  saveScore,
})(LossFrequency);




// WEBPACK FOOTER //
// ./src/components/ClientMode/LossFrequency.js